<script lang="ts" setup>
import {
  BlockCarouselImageSelectFields,
  BlockCarouselManualFields,
  BlockFooterCTAFields,
  BlockFormFields,
  BlockImageTextFields,
  BlockPoolNavigationFields,
  BlockPoolPaletteFields,
  BlockPoolUPSFields,
  BlockPoolVariantsFields,
  BlockSingleQuoteFields,
} from '~/utils/CmsBlockFields'

const { $directus, $readItems, $readItem } = useNuxtApp()

const route = useRoute()
const { t } = useI18n()
const signatureStore = useSignatureStore()

const { data, error } = await useAsyncData('pool_detail', async () => {
  const pools = await $directus.request($readItems('pools', {
    filter: {
      slug: {
        _eq: route.params.slug,
      },
      status: {
        _eq: 'published',
      },
    },
  }))
  if (pools.length === 0) {
    console.error('Pool not found')
    throw createError({
      statusCode: 404,
      message: 'no published pool with that slug found',
    })
  }

  return await $directus.request($readItem('pools', pools[0]?.id, {
    fields: [
      'id',
      'slug',
      'color_scheme',
      {
        seo: ['*', {
          translations: ['*'],
        }],
        page_translations: ['*'],
        hero_image: ['*'],
        hero_video: ['*'],
        tech_specs: ['*', {
          pool_tech_spec_id: ['*', {
            translations: ['*'],
          }],
        }],

        blocks: [
          'collection',
          'id',
          {
            item: {
              block_carousel_manual: BlockCarouselManualFields, //
              block_pool_navigation: BlockPoolNavigationFields, //
              block_single_quote: BlockSingleQuoteFields, //
              block_image_text: BlockImageTextFields, //
              block_footer_cta: BlockFooterCTAFields, //
              block_form: BlockFormFields,

              // Pool Detail Specific
              block_pool_ups: BlockPoolUPSFields,
              block_pool_variants: BlockPoolVariantsFields,
              block_pool_palette: BlockPoolPaletteFields,
              block_carousel_image_select: BlockCarouselImageSelectFields,

            },
          },
        ],
      },
    ],
  }))
})

if (error.value) {
  throw createError({
    fatal: true,
    statusCode: 404,
    message: 'Pool not found',
  })
}

signatureStore.setIsSignaturePage(data.value?.color_scheme === 'signature')
</script>

<template>
  <main
    :data-is-signature-page="signatureStore.isSignaturePage.value"
    class="signature-page:bg-signature-black"
  >
    <HeroDetail
      :data="{
        hero_image: data?.hero_image,
        hero_video: data?.hero_video,
        translations: data?.page_translations,
      } as any
      "
      :back-button="{
        text: t('general.back_to_overview'),
        link: '/pools',
      }"
    />
    <div>
      <div v-for="block in data?.blocks" :key="block.id">
        <BlockPoolNavigation v-if="block.collection === 'block_pool_navigation'" />
        <BlockSingleQuote v-if="block.collection === 'block_single_quote'" :data="block.item" />
        <BlockImageText v-if="block.collection === 'block_image_text'" :data="block.item" />
        <BlockCarouselManual v-if="block.collection === 'block_carousel_manual'" :data="block.item" />
        <BlockFooterCTA v-if="block.collection === 'block_footer_cta'" :data="block.item" />
        <BlockForm v-else-if="block.collection === 'block_form'" :data="block.item" />

        <!-- Pool Detail Specific -->
        <BlockPoolUPS v-if="block.collection === 'block_pool_ups'" :data="block.item" />
        <BlockPoolVariants v-if="block.collection === 'block_pool_variants'" :specs="data?.tech_specs!" :data="block.item" />
        <BlockPoolPalette v-if="block.collection === 'block_pool_palette'" :data="block.item" />
        <BlockCarouselImageSelect v-if="block.collection === 'block_carousel_image_select'" :data="block.item" />
      </div>
      <!-- <pre>{{ data }}</pre> -->
    </div>
  </main>
</template>
